import {
    nextTick, unref,
} from 'vue';
import {
    ERROR_CLASS,
    focusFirstStatus,
} from '../utils/form-focus';

export function useFormValidation(v$, el) {
    const validate = () => {
        if (!unref(v$)) return true;
        unref(v$).$touch();
        if (unref(v$).$error) {
            nextTick(() => {
                const element = el.value?.$el ?? el.value;
                const firstErrorElement = element?.querySelector(ERROR_CLASS);
                focusFirstStatus(firstErrorElement);
            });
        }
        return !unref(v$).$error;
    };

    return {
        validate,
    };
}
